import styled from 'styled-components';

import { FreeDeliveryProgressBarWrapper, FreeDeliveryProgressBarWrapperWithReco } from '@sharedComponents/ProgressBars';

export const StyledCartFreeDeliveryWrapper = styled(FreeDeliveryProgressBarWrapper)`
  margin-top: 1.125rem;
`;

export const StyledCartFreeDeliveryWrapperWithReco = styled(FreeDeliveryProgressBarWrapperWithReco)`
  margin-top: 1.125rem;
`;
